module.exports = __webpack_public_path__ + "static/media/innova_students.5c0b9269.png";